import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { useMutation } from "@tanstack/react-query";

export const useDeleteJobsMutation = () => {
  return useMutation({
    mutationFn: async (jobId: number) => {
      await apiClient.delete(ENDPOINTS.DELETE_JOB(jobId));
      return;
    },
  });
};
